import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

interface Props {
    message: string;
    title: string;
    open: boolean;
    isLoading?: boolean;
    handleClose: () => void;
    handleConfirm: () => void;
}

export default function AlertDialog({
    message,
    title,
    open,
    isLoading,
    handleClose,
    handleConfirm,
}: Props) {
    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>{title || 'Alert'}</DialogTitle>
            <DialogContent>
                <DialogContentText>{message}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={handleClose}>
                    Cancel
                </Button>
                <Button variant="contained" onClick={handleConfirm} disabled={isLoading} autoFocus>
                    Accept
                </Button>
            </DialogActions>
        </Dialog>
    );
}
